module.exports = __webpack_public_path__ + "img/ico-edit.bf72975b.svg";